import React from "react";
import ReactEChartsCore from "echarts-for-react/lib/core";
import * as echarts from "echarts/core";
import { getColor } from "helpers/utils";
import { tooltipFormatter } from "helpers/echart-utils";

function BarGraphColumn({ totalTodaySums, totalYesterdaySums }) {
  const months = [
    "Shopify",
    "Native",
    "CRM",
    "App",
    "Juspay",
    "Total Sum",
  ];

  function sumData(data) {
    const result = [];
    for (let i in data) {
      result.push(data[i].toFixed(2));
    }
    return result;
  }

  function totalSum(data) {
    let sum = 0;
    for (let i in data) {
      sum += data[i];
    }
    return sum.toFixed(2);
  }

  const todayResult = sumData(totalTodaySums);
  const yesterdayResult = sumData(totalYesterdaySums);
  const totalSumToday = totalSum(totalTodaySums);
  const yesterdaySum = totalSum(totalYesterdaySums);
  const allTodayData = [...todayResult, totalSumToday];
  const allYesterdayData = [...yesterdayResult, yesterdaySum];

  const getOption = () => ({
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "cross",
        crossStyle: {
          color: getColor("gray-500"),
        },
        label: {
          show: true,
          backgroundColor: getColor("gray-600"),
          color: getColor("gray-100"),
        },
      },
      padding: [7, 10],
      backgroundColor: getColor("gray-100"),
      borderColor: getColor("gray-300"),
      textStyle: { color: getColor("dark") },
      borderWidth: 1,
      transitionDuration: 0,
      formatter: tooltipFormatter,
    },
    toolbox: {
      top: 0,
      feature: {
        dataView: { show: false },
        magicType: {
          show: true,
          type: ["line", "bar"],
        },
        restore: { show: true },
        saveAsImage: { show: true },
      },
      iconStyle: {
        borderColor: getColor("gray-700"),
        borderWidth: 1,
      },

      emphasis: {
        iconStyle: {
          textFill: getColor("gray-600"),
        },
      },
    },
    legend: {
      top: 40,
      data: ["Today", "Yesterday"],
      textStyle: {
        color: getColor("gray-600"),
      },
    },
    xAxis: [
      {
        type: "category",
        data: months,
        axisLabel: {
          color: getColor("gray-600"),
          formatter: (value) => value.slice(0, 10),
        },
        axisPointer: {
          type: "shadow",
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: getColor("gray-300"),
          },
        },
      },
    ],
    yAxis: [
      {
        type: "value",
        axisLabel: {
          color: getColor("gray-600"),
          formatter: "{value}",
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: getColor("gray-200"),
          },
        },
      },
    ],
    series: [
      {
        name: "Today",
        type: "bar",
        data: allTodayData,
        itemStyle: {
          color: getColor("primary"),
          borderRadius: [3, 3, 0, 0],
        },
      },
      {
        name: "Yesterday",
        type: "bar",
        data: allYesterdayData,
        itemStyle: {
          color: getColor("info"),
          borderRadius: [3, 3, 0, 0],
        },
      },
    ],
    grid: {
      right: 5,
      left: 5,
      bottom: 5,
      top: "23%",
      containLabel: true,
    },
  });

  return (
    <ReactEChartsCore
      echarts={echarts}
      option={getOption()}
      style={{ height: "21.88rem" }}
    />
  );
}

export default BarGraphColumn;
